module.exports = __webpack_public_path__ + "img/chain16.ce089ff5.png";